import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {formValueSelector} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {getActivePermissions} = customer.selectors;

import {getCareSheetSettings, uploadLogo, saveStoreSettings} from '../actions';
import {areSettingsValid, getStoreSettings} from '../selectors';

import StoreInfoForm from './StoreInfoForm';

import * as permissions from '../../common/userPermissions';

const formName = 'storeInfoForm';
const formSelector = formValueSelector(formName);

class StoreInfoPage extends React.Component {
  componentWillMount() {
    const accessPermission = this.props.activePermissions.find((permission) => {
      return permission === permissions.MANAGE_LOGO;
    });
    if(!accessPermission)
    {
      this.props.actions.push('/labels');
    } 

    this.props.actions.getCareSheetSettings();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.authData.activeSubscriptionId !== nextProps.authData.activeSubscriptionId) {
      this.props.actions.getCareSheetSettings();
    }
  }

  handleFormSubmit = (values) => {
    return new Promise((resolve, reject) => {
      this.props.actions.saveStoreSettings(values)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  render() {
    const {actions: {uploadLogo}, useLogo, storeSettings, validSettings} = this.props;
    return(
      <div className="container-fluid main" id="main">
        <div className="row">
          <div className="col-lg-12">
            <h1>{I18n.t('STORE_INFO_LOGO')}</h1>
            <p>{I18n.t('STORE_INFO_DETAILS')}</p>
            {!validSettings && <div className="loading"/>} 
            {validSettings && <div><div className="row no-gutters">
              <div className="col-sm-12">
                <h5>{I18n.t('STORE_INFO')}</h5>
              </div>
            </div> 
            <StoreInfoForm form={formName} 
                           initialValues={{line1: storeSettings.infoLine1, 
                                            line2: storeSettings.infoLine2, 
                                            line3: storeSettings.infoLine3, 
                                            line4: storeSettings.infoLine4,
                                            useLogo: storeSettings.useLogo}}
                           onSubmit={this.handleFormSubmit}
                           onUpload={uploadLogo}
                           storeSettings={storeSettings}
                           useLogo={useLogo}/>
            </div>}
          </div>
        </div>
      </div>
    );
  }
}
  
function mapStateToProps(state) {
  return {
    activePermissions: getActivePermissions(state),
    useLogo: formSelector(state, 'useLogo'),
    storeSettings: getStoreSettings(state),
    validSettings: areSettingsValid(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({getCareSheetSettings, uploadLogo, saveStoreSettings, push}, dispatch)
  };
}

StoreInfoPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activePermissions: PropTypes.array.isRequired,
  authData: PropTypes.object.isRequired,
  storeSettings: PropTypes.object.isRequired,
  useLogo: PropTypes.bool,
  validSettings: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreInfoPage);


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/StoreInfoPage.js
 **/